var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionMapUpdatesColoredDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15 20L9 18V4L15 6V20Z",
    fill: "#5714CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.8918L15 18.8918V7.10819L9 5.10819V16.8918ZM15 21L9 19L4.31623 20.5613C3.6687 20.7771 3 20.2951 3 19.6126V5.72076C3 5.29033 3.27543 4.90819 3.68377 4.77208L9 3L15 5L19.6838 3.43874C20.3313 3.2229 21 3.70487 21 4.38743V18.2792C21 18.7097 20.7246 19.0918 20.3162 19.2279L15 21Z",
    fill: "#5714CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17C24 20.866 20.866 24 17 24C13.134 24 10 20.866 10 17C10 13.134 13.134 10 17 10C20.866 10 24 13.134 24 17Z",
    fill: "#FFC30D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17H17L20 20L23 17H21C21 14.7909 19.2091 13 17 13C14.7909 13 13 14.7909 13 17C13 19.2091 14.7909 21 17 21V19Z",
    fill: "#5714CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionMapUpdatesColoredDay);
export default __webpack_public_path__ + "static/media/ic_action_map_updates_colored_day.4e293038cac6940ed17f4007699fc9dc.svg";
export { ForwardRef as ReactComponent };